import { openLoginWindow } from '@/utils'

export const openLoginWithMicrosoftWindow = () => {
  const scopesStr= `?scopes=${process.env.VUE_APP_MICROSOFT_SCOPES}`
  const fullUrl = `${process.env.VUE_APP_MICROSOFT_LOGIN_LINK}${scopesStr}`
  openLoginWindow(fullUrl, 'microsoft')
}
